import React, { useState } from 'react';
import { Redirect } from 'react-router';
import { useHistory } from 'react-router-dom';

export const ActivateAccount = (props) => {

	const { firebase, actionCode, authUser } = props

	const history = useHistory()

	const [error, setError] = useState({})
	const [loading, setLoading] = useState(false)

	const handleSubmit = () => {
		setLoading(true)
		firebase
			.verifyEmailAddress(actionCode)
			.then(() => {
				window.location.reload(false)
				history.push('/')
				setLoading(false)
			})
			.catch((err) => setError(err))
		setLoading(false)
	}
	return (authUser && !authUser.emailVerified) ?  (
		<div className="container text-center">
			<p>Click the button below to activate the account and access your profile</p>

			<button className="w-100 rn-button-style--2 btn-solid" onClick={handleSubmit} disabled={loading} name="registration">Activate account</button>

			{error && <p className="error">{error.message}</p>}
		</div>) : <Redirect to={'/account'} />
}


